/* Video Testimonial section — vanilla JS, no video bytes load until tap. */
(function () {
  'use strict';

  function vtTrack(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
      }
    } catch (e) {
      /* tracking must never break the page */
    }
  }

  function pickSource(sources) {
    var mp4 = sources.filter(function (s) {
      return s.format === 'mp4' && s.url;
    });
    if (!mp4.length) return null;

    var inRange = mp4.filter(function (s) {
      return s.width <= 1080;
    });

    if (!inRange.length) {
      return mp4.slice().sort(function (a, b) {
        return a.width - b.width;
      })[0];
    }

    return inRange.slice().sort(function (a, b) {
      return Math.abs(a.width - 720) - Math.abs(b.width - 720);
    })[0];
  }

  function initSection(section) {
    if (section.hasAttribute('data-vt-ready')) return;
    section.setAttribute('data-vt-ready', '');

    var dialog = section.querySelector('[data-vt-dialog]');
    var videoWrap = section.querySelector('[data-vt-video-wrap]');
    var openBtn = section.querySelector('[data-vt-open]');
    var closeBtn = section.querySelector('[data-vt-close]');
    var endscreen = section.querySelector('[data-vt-endscreen]');
    var replayBtn = section.querySelector('[data-vt-replay]');
    var sourcesScript = section.querySelector('[data-vt-sources]');
    var ctaEls = section.querySelectorAll('[data-vt-track-cta]');

    if (!dialog || !videoWrap || !openBtn || !sourcesScript) return;

    var videoName = section.getAttribute('data-video-name') || '';
    var sources = [];
    try {
      sources = JSON.parse(sourcesScript.textContent) || [];
    } catch (e) {
      sources = [];
    }

    var video = null;
    var halfwayFired = false;

    function lockScroll() {
      document.documentElement.classList.add('vt-no-scroll');
    }

    function unlockScroll() {
      document.documentElement.classList.remove('vt-no-scroll');
    }

    function createVideo() {
      var source = pickSource(sources);
      if (!source) return null;

      var v = document.createElement('video');
      v.setAttribute('playsinline', '');
      v.controls = true;
      v.autoplay = true;
      v.muted = false;
      v.src = source.url;

      v.addEventListener('timeupdate', function () {
        if (!halfwayFired && v.duration && v.currentTime / v.duration >= 0.5) {
          halfwayFired = true;
          vtTrack('video_testimonial_50', { video_name: videoName });
        }
      });

      v.addEventListener('ended', function () {
        vtTrack('video_testimonial_complete', { video_name: videoName });
        if (endscreen) endscreen.hidden = false;
      });

      return v;
    }

    function openVideo() {
      halfwayFired = false;
      if (endscreen) endscreen.hidden = true;
      videoWrap.innerHTML = '';
      video = createVideo();
      if (!video) return;
      videoWrap.appendChild(video);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      lockScroll();

      try {
        video.play().catch(function () {});
      } catch (e) {}

      vtTrack('video_testimonial_open', { video_name: videoName });
    }

    function closeVideo() {
      if (video) {
        try {
          video.pause();
          video.removeAttribute('src');
          video.load();
        } catch (e) {}
      }
      videoWrap.innerHTML = '';
      video = null;
      if (endscreen) endscreen.hidden = true;

      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      unlockScroll();
      openBtn.focus();
    }

    function replayVideo() {
      if (endscreen) endscreen.hidden = true;
      halfwayFired = false;
      videoWrap.innerHTML = '';
      video = createVideo();
      if (!video) return;
      videoWrap.appendChild(video);
      try {
        video.play().catch(function () {});
      } catch (e) {}
    }

    openBtn.addEventListener('click', openVideo);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeVideo);
    }

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeVideo();
    });

    dialog.addEventListener('click', function (e) {
      if (
        e.target === dialog ||
        e.target.classList.contains('vt__dialog-inner') ||
        e.target.classList.contains('vt__video-wrap')
      ) {
        closeVideo();
      }
    });

    if (replayBtn) {
      replayBtn.addEventListener('click', replayVideo);
    }

    ctaEls.forEach(function (el) {
      el.addEventListener('click', function () {
        vtTrack('video_testimonial_cta_click', {
          video_name: videoName,
          button_label: el.getAttribute('data-button-label') || ''
        });
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-vt-section]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-vt-section]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('vt-no-scroll');
  });
})();
